import { ChangeDetectorRef, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@app/utils/get-api-url';
// import { TemplatesConfigService } from '@app/features/system-settings/general-custom-templates-config/services/templates-config.service';
import { SystemSettingsService } from '@app/services';
import { JobViewService } from "@app/features/customers/customer/jobs-view/service/job-view-service";
var AddPricingItem = /** @class */ (function () {
    function AddPricingItem(formBuilder, ajsScope, 
    // private httpService: TemplatesConfigService,
    bsModalRef, changeDetector, systemSettingsService, jobViewService) {
        this.formBuilder = formBuilder;
        this.ajsScope = ajsScope;
        this.bsModalRef = bsModalRef;
        this.changeDetector = changeDetector;
        this.systemSettingsService = systemSettingsService;
        this.jobViewService = jobViewService;
        this.title = 'Add new pricing item';
        this.closeBtnName = 'Cancel';
        this.action = '';
        this.formModel = {
            pricing_item: '',
            unitprice: '',
            qty: '',
            tax: '',
            min_included: '',
            total: ''
        };
        this.selectedKitParts = [];
        this.enablePartStatus = 3;
        this.select2PartStatusConfig = {};
        this.partStatus = [];
        this.searchResults = [];
        this.seletedItem = null;
        this.taxList = [];
        this.excludePricingItems = [];
        this.select2TaxConfig = {};
        this.taxLable = 'VAT';
    }
    AddPricingItem.prototype.ngOnInit = function () {
        this.taxLable = this.ajsScope.taxLabel;
        this.onClose = new Subject();
        this.form = this.formBuilder.group({
            pricing_item: [this.formModel.pricing_item, Validators.required],
            unitprice: [this.formModel.unitprice, [Validators.required]],
            qty: [this.formModel.qty, [Validators.required, Validators.pattern(/^\d+$/), Validators.min(1)]],
            tax: [this.formModel.tax, Validators.required],
            min_included: [this.formModel.min_included, [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/), Validators.min(0)]],
            total: [this.formModel.total, Validators.required],
        });
        this.select2TaxConfig = {
            width: '100%',
            data: this.taxList
        };
        this.initSelect2Config();
    };
    AddPricingItem.prototype.initSelect2Config = function () {
        var _this = this;
        var excludePricingItems = (this.excludePricingItems || [])
            .map(function (id) { return String(id).trim(); })
            .filter(function (id) { return id !== ''; })
            .join(',');
        this.select2Config = {
            multiple: false,
            width: '100%',
            placeholder: 'Select a part kit',
            allowClear: true,
            minimumInputLength: 2,
            ajax: {
                url: "" + environment.apiHost + environment.apiBasePath + "get_pricing_items?customerId=" + this.customerId + "&contractId=" + this.contractId + "&excludePricingItems=" + encodeURIComponent(excludePricingItems),
                data: function (searchText, page) {
                    if (!searchText) {
                        return false;
                    }
                    return { 'q': encodeURIComponent(searchText) };
                },
                results: function (data) {
                    _this.searchResults = data;
                    return { results: data || [] };
                }
            }
        };
    };
    Object.defineProperty(AddPricingItem.prototype, "f", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    AddPricingItem.prototype.save = function () {
        var _this = this;
        if (this.form.invalid) {
            return;
        }
        this.action = 'saving';
        var innerPayload = {
            pricing_item: String(this.form.get('pricing_item').value),
            PI_includedMinutes: String(this.form.get('min_included').value),
            PI_quantity: String(this.form.get('qty').value),
            PI_total: String(this.form.get('total').value),
            PI_unitprice: String(this.form.get('unitprice').value),
            Tax_rate_id: String(this.form.get('tax').value),
        };
        var formData = new FormData();
        formData.append('data', JSON.stringify(innerPayload));
        this.jobViewService.savePricingItem(this.customerId, this.jobId, this.customerType, formData)
            .subscribe(function (resp) {
            _this.action = '';
            _this.onClose.next(true);
            _this.bsModalRef.hide();
        }, function (error) {
            _this.action = '';
            console.error('Error saving:', error);
        });
    };
    AddPricingItem.prototype.onSelectingCondition = function (id) {
        this.seletedItem = this.searchResults.find(function (obj) { return obj.id == id; });
        if (this.seletedItem) {
            this.form.patchValue({
                pricing_item: this.seletedItem.id || '',
                unitprice: this.seletedItem.unitprice,
                vat: this.seletedItem.Vat,
                tax: this.seletedItem.taxId,
                min_included: '0',
                qty: 1
            });
            var taxSelect = document.getElementById('tax');
            if (taxSelect && $(taxSelect).data('select2')) {
                $(taxSelect).val(this.seletedItem.taxId).trigger('change');
            }
            this.onQtyKeyup();
        }
        else {
            this.form.patchValue({ unitprice: '' });
        }
    };
    AddPricingItem.prototype.onQtyKeyup = function () {
        this.updateTotal();
    };
    AddPricingItem.prototype.updateTotal = function () {
        var qtyCtrl = this.form.get('qty');
        var unitCtrl = this.form.get('unitprice');
        var totalCtrl = this.form.get('total');
        var qtyRaw = qtyCtrl ? qtyCtrl.value : null;
        var unitRaw = unitCtrl ? unitCtrl.value : null;
        var qty = Number(qtyRaw || 0);
        var unit = Number(unitRaw || 0);
        if (!isFinite(qty) || !isFinite(unit)) {
            if (totalCtrl) {
                totalCtrl.setValue('', { emitEvent: false });
            }
            return;
        }
        var total = unit * qty;
        if (totalCtrl) {
            totalCtrl.setValue(total.toFixed(2), { emitEvent: false });
        }
    };
    return AddPricingItem;
}());
export { AddPricingItem };
